import {checkboxAnatomy} from '@chakra-ui/anatomy'
import {createMultiStyleConfigHelpers} from '@chakra-ui/react'

const {definePartsStyle, defineMultiStyleConfig} =
  createMultiStyleConfigHelpers(checkboxAnatomy.keys)

const baseStyle = definePartsStyle({
  control: {
    backgroundColor: 'white',
    borderColor: 'pg50',
    _readOnly: {
      bg: 'pg20',
    },
    _disabled: {
      bg: 'pg20',
      borderColor: 'pg50',
    },
    _checked: {
      borderColor: 'pg50',

      _readOnly: {
        borderColor: 'pg50',
        color: 'pg50',
      },
      _disabled: {
        bg: 'pg20',
        borderColor: 'pg50',
      },
    },
  },
  label: {
    _disabled: {
      color: 'pg100 ',
      opacity: 1,
    },
  },
})

export const CheckboxStyles = defineMultiStyleConfig({baseStyle})
